import { combineReducers } from 'redux';
import licenseReducer from './license.reducers';
import siteReducer from './site.reducers';
import authenticationReducer from './authentication.reducers';
import personReducer from './person.reducers';
import accountingReducer from './accounting.reducers';
import InspectionDetailReducer from './inspection.reducers';
import violationReducer from './violation.reducers';
import calendarReducer from './calendar.reducers';
import timeSheetReducer from './timeSheet.reducers';
import citationReducer from './citation.reducers';
import inboxReducer from './inbox.reducers';

const rootReducer = combineReducers({
    application: licenseReducer,
    site: siteReducer,
    authentication: authenticationReducer,
    person: personReducer,
    accounting: accountingReducer,
    inspectionDetail: InspectionDetailReducer,
    violation: violationReducer,
    calendar: calendarReducer,
    timeAndExpense: timeSheetReducer,
    citation: citationReducer,
    inbox: inboxReducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
